export default {
  storeApi: '/api/Vip/Public/ShopInfo', // 店铺api
  vipApi: '/api/Vip/VipInfos/GetListPaged', // 会员api
  productApi: '/api/productManagement/products', // 商品api
}